import React, { memo } from 'react';
import classnames from 'classnames';
import './index.scss';

interface IShowAllToggleBtnProps extends IBaseProps {
  textAlign?: 'left' | 'center' | 'right';
  showAllText?: string;
  showLessText?: string;
  isShowAll: boolean;
  setIsShowAll: React.Dispatch<React.SetStateAction<boolean>>;
}

const ShowAllToggleBtn: React.FC<IShowAllToggleBtnProps> = (props) => {
  const {
    textAlign = 'right',
    showAllText = 'Show All',
    showLessText = 'Show Less',
    isShowAll,
    setIsShowAll,
    style,
    className,
    ...remains
  } = props;

  const handleShowAllToggle = (value: boolean) => {
    setIsShowAll(value);
  };

  return (
    <div
      {...remains}
      style={{
        ...style,
        textAlign,
      }}
      className={classnames('gp-common-is-show-all-toggle-btn', className)}
    >
      {isShowAll ? (
        <span
          className="gp-common-is-show-all-toggle-btn-text"
          onClick={() => {
            handleShowAllToggle(false);
          }}
        >
          {showLessText}
        </span>
      ) : (
        <span
          className="gp-common-is-show-all-toggle-btn-text"
          onClick={() => {
            handleShowAllToggle(true);
          }}
        >
          {showAllText}
        </span>
      )}
    </div>
  );
};

export default memo(ShowAllToggleBtn);
